<template>
  <div class="new-tag">
    <el-tag v-for="(tag, index) in dynamicTags" :key="index" closable :disable-transitions="false"
      @close="handleClose(tag)">
      {{tag}}
    </el-tag>
    <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
      @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
    </el-input>
    <el-button class="button-new-tag" v-else @click="showInput">+ 添加</el-button>
  </div>
</template>

<script>
export default {
  props: {
    dynamicTags: Array
  },
  data() {
    return {
      inputVisible: false,
      inputValue: ''
    };
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },

    showInput() {
      this.inputVisible = true;
      this.$nextTick(_ => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },

    handleInputConfirm() {
      let inputValue = this.inputValue;
      // 增加标签过滤校验
      if (inputValue) {
        this.dynamicTags.push(inputValue);
        this.inputVisible = false;
        this.inputValue = '';
      }
    }
  }
};
</script>
<style scoped>
.el-tag {
  margin-right: 10px;
}
.button-new-tag {
  margin-left: 0px;
  height: 32px !important;
  line-height: 30px !important;
  padding-top: 0;
  padding-bottom: 0;
  font-size: 12px;
  border-radius: 3px;
}
.input-new-tag {
  height: 32px;
  width: 90px;
  margin-left: 0px;
  vertical-align: bottom;
}
.el-tag {
  background-color: #f9f6f6;
  padding: 0 10px;
  height: 32px;
  line-height: 30px;
  font-size: 12px;
  color: #f05952;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #f9f6f6;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/common/component/newTag.vue